import React from 'react'
import Calc from './Calc'
import './App.css'

const App = () => {
  return (
    <>
    <Calc/>
    </>
  )
}

export default App
